export default __webpack_public_path__ + "static/media/cv-files-table.e270a0ee.gif";